module.exports = __webpack_public_path__ + "static/img/album4_202501_01.163137c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/csr/fight-epidemic/album4_202501_01.jpg
// module id = lrjn
// module chunks = 98